import { render, staticRenderFns } from "./healthcareView.vue?vue&type=template&id=e7379f44&scoped=true"
import script from "./healthcareView.vue?vue&type=script&lang=js"
export * from "./healthcareView.vue?vue&type=script&lang=js"
import style0 from "./healthcareView.vue?vue&type=style&index=0&id=e7379f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7379f44",
  null
  
)

export default component.exports